(function(global, factory){
    if (typeof exports === 'object') {
        module.exports = factory(
            require('jquery')
        );
    } else if ( typeof define === 'function' && define.amd ) {
        define(['jquery'], factory);
    }
}(this, function(jQuery){

    var $ = jQuery;

    if ('undefined' === typeof window.gettext) {
        var gettext = function gettext(string) { return string; };
        var pgettext = function pgettext(context, string) {
            if ( context ) { return string; }
            return context;
        };
        var ngettext = function ngettext(string, plural, opts){
            if(opts[0] != 1) { return plural; }
            return string;
        }
    } else {
        var gettext = window.gettext;
        var pgettext = window.pgettext;
        var ngettext = window.ngettext;

    }

    var i18n = {};

    var __js = i18n['__js'] = function(string, opts) {
        return i18n.localize(string, opts);
    };

    var __jsc = i18n['__jsc'] = function(string, context, opts) {
        return i18n.localize(string, opts, context);
    };

    var __pl = i18n['__pl'] = function(string, plural, opts) {
        return i18n.localizePlural(string, plural, opts);
    };

    var addBrs = i18n['addBrs'] = function(text) {
        return text
            .replace(/\n/g, "<br />");
    };

    var addFormatting = i18n['addFormatting'] = function(text) {
        return text.replace(/^\*(.*)\*$/gm, "<b>$1</b>")
            .replace(/\n/g, "<br />");
    };

    i18n.date = {
        basicFormat: "",
        fhdFormat: "M/D/Y",
        reSubparts: {
            "D" : "\\d{1,2}",
            "M" : "\\d{1,2}",
            "Y" : "\\d{4}"
        },

        hardcodedFormats: {
            "en_US": "M/D/Y",
            "en-us": "M/D/Y",
            "es_ES": "D/M/Y",
            "es-es": "D/M/Y",
            "de": ""
        },

        inited: false,

        init: function() {
            if(this.inited) return;
            this.inited = true;
            var basicDate = new Date(3333, 10, 22, 0,0,0,0),
                localDateString;

            if ('undefined' !== typeof navigator) {
                var ua = navigator.userAgent.toLowerCase();
                if (ua.indexOf('safari') != -1) {
                    if (ua.indexOf('chrome') > -1) {
                        localDateString = basicDate.toLocaleDateString();
                    } else {
                        localDateString = basicDate.toLocaleDateString("short");
                    }
                }
            } else {
                localDateString = basicDate.toLocaleDateString("short");
            }


            if(/[a-zA-Z]/.test(localDateString)) { // Safari on mac. Kill it with fire
                /*this.basicFormat = this.hardcodedFormats[navigator.language];
                 if(!this.basicFormat) {
                 this.basicFormat = this.hardcodedFormats[window.locale];
                 }*/
                this.basicFormat = this.hardcodedFormats["en-us"];
            } else {
                var ieRe = new RegExp(String.fromCharCode(8206), "g");


                this.basicFormat = localDateString.replace("3333", "Y").replace("33", "Y").
                    replace("11", "M").replace("22", "D").replace("21", "D").replace(ieRe, "");;
            }
        },

        validator: function() {
            return this.createValidator(this.basicFormat);
        },

        createValidator: function(expr) {
            var preRE = expr.replace(/\./g, "\\.");
            for(var x in this.reSubparts) {
                preRE = preRE.replace(x, "(" + this.reSubparts[x] + ")");
            }

            return new RegExp(preRE);
        },

        placeholder: function() {
            this.init();
            var placeholderVariants = {
                "M/D/Y": __js("MM/dd/YYYY"),
                "D/M/Y": __js("dd/MM/YYYY"),
                "D.M.Y": __js("dd.MM.YYYY"),
                "Y/M/D": __js("YYYY/MM/dd")
            };

            var out = placeholderVariants[this.basicFormat];

            if(out) {
                return out;
            }

            return placeholderVariants["M/D/Y"]; //default
        },

        getRePositions: function(inputFormat) {
            if(!inputFormat) {
                inputFormat = this.basicFormat;
            }
            var inpPositions = {}, i = 1;
            for(var j = 0; j < inputFormat.length; j++) {
                for(var k in this.reSubparts) {
                    if(k == inputFormat[j]) {
                        inpPositions[k] = i++;
                        break;
                    }
                }
            }

            return inpPositions;
        },

        formatJSDateToMysqlFormat:function(date){
            var day = date.getUTCDate(),
                month = date.getUTCMonth()+1,
                year = date.getUTCFullYear(),
                hour = date.getUTCHours(),
                minute = date.getUTCMinutes(),
                second = date.getUTCSeconds();
            return year + "-" + month + "-" + day+ " "+ hour + ":"+ minute + ":" + second;
        },        

        formatDate: function(outputFormat, inputFormat, date) {
            var outDate = outputFormat ? outputFormat : this.basicFormat,
                inputRe = inputFormat;

            if(!this.createValidator(inputFormat).test(date)) {
                return date;
            }
            var inpPositions = this.getRePositions(inputFormat);

            for(var x in this.reSubparts) {
                outDate = outDate.replace(x, "$" + inpPositions[x]);
                inputRe = inputRe.replace(x, "(" + this.reSubparts[x] + ")");
            }

            var re = new RegExp(inputRe);

            return date.replace(re, outDate);
        },

        toLocalDate: function(date) {
            if(!date) return "";
            this.init();
            return this.formatDate(this.basicFormat, this.fhdFormat, date).replace("yrs", __js("yrs"));
        },

        toFHDDate: function(date) {
            this.init();
            return this.formatDate(this.fhdFormat, this.basicFormat, date).replace(__js("yrs"), "yrs");
        }
    };


    i18n.localize = function(string, opts, context) {
        var outString;
        if ( context ) {
            outString = pgettext(context, string);
        } else {
            outString = gettext(string);
        }
        outString = applyParams(outString, opts);
        return outString;
    };

    i18n.localizePlural = function(string, plural, opts) {
        return ngettext(string, plural, opts);
    };

    var applyParams = function(content, opts) {
        if(opts) {
            for(var i = 0; i < opts.length; i++) {
                content = content.replace(new RegExp("%(" + (i + 1) + "\\$)?[d@]"), opts[i]);
            }
        }

        return content;
    };

    i18n.evalCommand = function(object, cmd, content) {
        content = content.trim().replace(/\\n/g, "\n").replace(/\\"/g, "\"");
        switch(cmd.trim()) {
            case "msgid":
                object.msgid = content;
                break;
            case "msgid_plural":
                object.msgidPlural = content;
                break;
            case "msgstr":
                object.msgstr = content;
                break;
            case "msgstr[0]":
                object.msgstr_0 = content;
                object.msgstr = content;
                break;
            case "msgstr[1]":
                object.msgstr_1 = content;
                break;
            case "msgctxt":
                object.ctxt = content;
        }

        return object;
    };



    /*
    * MomentJs does not accept not-ISO date format
    * */

    var DEFAULT_DATE_FORMAT = 'MM/DD/YYYY',
        ISO_DATE_FORMAT = 'YYYY-MM-DD';

    i18n._currentDateFormat = 'DEFAULT_DATE_FORMAT';

    i18n._dateFormats = {
        DEFAULT_DATE_FORMAT: {
            RE: /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/,
            MONTH: 0, DAY: 1, YEAR: 2,
            SEPARATOR: '/'
        },
        EUROPEAN_DATE_FORMAT: {
            RE: /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/,
            DAY: 0, MONTH: 1, YEAR: 2,
            SEPARATOR: '.'
        },
        ISO_DATE_FORMAT: {
            RE: /^(\d{4})-(\d{2})-(\d{2})$/,
            YEAR: 0, MONTH: 1, DAY: 2,
            SEPARATOR: '-'
        }
    };

    i18n.getDateFormat = function getDateFormat() { return i18n._currentDateFormat; };

    i18n.getDateFormatRegExp = function getDateFormatRegExp() {
        var currentFormat = i18n.getDateFormat();
        return i18n._dateFormats[currentFormat].RE;
    };

    i18n.validateDate = function validateDate(inputDate) {
        var formatRegExp = i18n.getDateFormatRegExp();
        return formatRegExp.test(inputDate);
    };

    i18n.recognizeDateFormat = function recognizeDateFormat(inputDate) {
        var formats = i18n._dateFormats,
            key, value, patternMatch;
        for (key in formats) {
            if (!formats.hasOwnProperty(key)) { continue; }
            value = formats[key];
            patternMatch = value.RE.test(inputDate.trim());
            if (patternMatch) { return key; }
        }
        throw new TypeError('Invalid date format');
    };

    i18n.toISODate = function toISODate(inputDate) {
        var dateFormatString = i18n.recognizeDateFormat(inputDate),
            dateFormat = i18n._dateFormats[dateFormatString],
            matchedArray = inputDate.match(dateFormat.RE).slice(1),
            day = matchedArray[dateFormat.DAY],
            month = matchedArray[dateFormat.MONTH],
            year = matchedArray[dateFormat.YEAR],
            SEPARATOR = i18n._dateFormats.ISO_DATE_FORMAT.SEPARATOR;
        return [ year, SEPARATOR, month, SEPARATOR, day ].join('');
    };


    if("undefined" != typeof window) {
        window.i18n = i18n;
        window.__js = i18n.__js
    }

    return i18n

}));
